<template>
    <Modal
            v-model="modalVisible"
            title="用户选择"
            :mask-closable="false"
            width="700"
            @on-ok="ok"
            @on-visible-change="change"
            @on-cancel="cancel">
        <Row>
            <Col span="8" style="height: 350px;overflow: auto">
                <Tree :data="deptArr" @on-select-change="listUser"></Tree>
            </Col>
            <Col span="1">
                <Divider style="height: 350px;" type="vertical"/>
            </Col>
            <Col span="15">
                <div>已选择用户</div>
                <Tag v-for="item in userCheck" type="dot" color="primary"  closable @on-close="handleTagClose(item.id)">{{item.name}}</Tag>
                <Divider/>
                <Table border ref="selection" :columns="columns" :data="dataTable"
                       @on-select="selectTable"
                       @on-select-cancel="cancelSelectTable"
                       @on-select-all = "selectAll"
                       @on-select-all-cancel = "cancelSelectAllUser"
                ></Table>
                <div class="page-div">
                    <Page :total="dataCount" :page-size="pageSize" @on-change="handlePageChange" show-total/>
                </div>
            </Col>
        </Row>
    </Modal>
</template>

<script>
    import util from "@/libs/util.js";

    export default {
        name: "UserRuleSetWin",
        data() {
            return {
                modalVisible: false,
                tableId: null,
                dataCount: 0,
                pageSize: 3,
                page: 1,
                user: null,
                userCheck: [],
                deptArr: [],
                dataTable: [],
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '姓名',
                        key: 'name',
                        align: 'center'
                    }
                ]
            };
        },
        watch: {
            user: function (value) {
                if (value === null) return;
                if (typeof (value.value) == 'undefined' || value.value === null) return;
                this.userCheck = value.value;
            }
        },
        methods: {
            initTree() {
                let This = this;
                util.http.get('/api/system/cscpOrgs').then(response => {
                    let arr = response.data.data;
                    let r_arr = [];
                    for (let i = 0; i < arr.length; i++) {
                        let map = {
                            id: arr[i].id,
                            title: arr[i].orgName,
                            expand: false,
                            parentId: arr[i].parentId
                        }
                        r_arr.push(map);
                    }
                    This.deptArr = This.treeData(r_arr, 'id', 'parentId', 'children');
                    if (This.deptArr.length > 0) {
                        This.deptArr[0].expand = true;
                    }

                });

            },
            listUser(node) {
                this.tableId = node[0].id;
                this.page = 1;
                this.listTable();
            },
            listTable() {
                if (this.tableId === null || typeof (this.tableId) === 'undefined') return;
                let This = this;
                util.http.get('/api/activiti/user/page', {
                    params: {
                        orgId: This.tableId,
                        page: This.page,
                        size: This.pageSize
                    }
                }).then(response => {
                    This.dataTable = [];
                    let data = response.data;
                    This.dataCount = data.recordsTotal;
                    let list = data.data;
                    for (let i = 0; i < list.length; i++) {
                        let user = list[i];
                        let map = {
                            id: user.id,
                            _checked: false,
                            name: user.familyName + user.name
                        };
                        for (let j = 0; j < This.userCheck.length; j++) {
                            if (This.userCheck[j].id === user.id) {
                                map._checked = true;
                            }
                        }
                        This.dataTable.push(map);
                    }
                });
            },
            selectTable(selection, row) {
                this.userCheck.push(row)
            },
            cancelSelectTable(selection, row) {
                for (let i = 0; i < this.userCheck.length; i++) {
                    if (this.userCheck[i].id === row.id) {
                        this.userCheck.splice(i, 1);
                    }
                }
            },
            selectAll(selection){
                let This = this;
                for (let i = 0; i < selection.length; i++) {
                    for (let j = 0; j < This.userCheck.length; j++) {
                        if(selection[i].id === This.userCheck[j].id){
                            selection.splice(i, 1);
                        }
                    }
                }

            this.userCheck = this.userCheck.concat(selection);

            },

            cancelSelectAllUser(selection){
                let This = this;
                for (let i = 0; i < This.dataTable.length; i++) {
                    for (let j = 0; j < This.userCheck.length; j++) {
                        if(This.dataTable[i].id === This.userCheck[j].id){
                            This.userCheck.splice(j, 1);
                        }
                    }
                }
            },
            handleTagClose(id){
                let This = this;
                for (let j = 0; j < This.userCheck.length; j++) {
                    if(id === This.userCheck[j].id){
                        This.userCheck.splice(j, 1);
                    }
                }
              this.listTable();

            },
            ok() {
                console.log(this.userCheck)
                if (this.user !== null) {
                    this.user.value = this.userCheck;
                    this.$emit('refreshAssigneeRule', this.user);
                }
            },
            change(flag) {
                if (!flag) {
                    this.user = null;
                    this.userCheck = [];
                    this.dataTable = [];
                    this.tableId = null;
                    this.dataCount = 0;
                    this.pageSize = 2;
                    this.page = 1;
                    this.deptArr = [];
                } else {
                    this.initTree()
                }
            },
            treeData(source, id, parentId, children) {
                return source.filter(father => {
                    let branchArr = source.filter(child => father[id] === child[parentId]);
                    branchArr.length > 0 ? father[children] = branchArr : ''
                    return father[parentId] === 0;
                })
            },
            handlePageChange(current) {
                this.page = current;
                this.listTable();
            },
            cancel() {
            }
        }
    }
</script>

<style scoped>
    .page-div {
        display: flex;
        justify-content: flex-end;
        padding-top: 35px;
        padding-right: 50px;
    }
</style>
